import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const LinkedInRediction = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        const code = query.get("code");
        const error = query.get("error");

        if (code) {
            fetch(`${process.env.REACT_APP_HOTE}/connexion-linkedin/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ code }),
            })
                .then(async res => {
                    const data = await res.json();
                    if (res.ok) {
                        localStorage.setItem("access_token", data.access);
                        localStorage.setItem("user_id", data.user_id);
                        localStorage.setItem("groupe", data.group_id);
                        if (res.status === 201) {
                            // Nouvel utilisateur
                            navigate("/activation-page", { state: { userId: data.user_id } });
                        } else {
                            // Utilisateur existant
                            navigate("/Parcours");
                        }
                    } else {
                        console.error("Erreur côté backend:", data);
                    }
                });
        } else if (error) {
            console.error("Erreur OAuth LinkedIn:", error);
        }
    }, [navigate]);


    return <div>Connexion LinkedIn en cours...</div>;
};

export default LinkedInRediction;
